import moment from 'moment/moment';

export const useDates = () => {
    const formatDate = (date: Date | string | undefined): string => {
        if (!date) {
            return '';
        }
        if (typeof date === 'string') {
            const utcMoment = moment.utc(date);
            return utcMoment.format('DD-MMM-yyyy');
        }
        return moment(date).format('DD-MMM-yyyy');
    };
    return {
        formatDate,
    };
};
